module.exports = __webpack_public_path__ + "static/tarjeta-residencia-d8facbefef473381109ca1d01f8658bd.svg";